// @ts-nocheck legacy file transformed to TS
const MILLISECONDS_PER_HOUR = 36e5

export function hourDifference(start, end) {
  return Math.round(Math.abs(end - start) / MILLISECONDS_PER_HOUR)
}

export function addHours(date, hours) {
  return new Date(date.getTime() + hours * MILLISECONDS_PER_HOUR)
}

export function timeZoneOffset(dateString) {
  return parseInt(dateString.substring(dateString.length - 6, dateString.length - 3), 10)
}

export function withinDates(date, minDate, maxDate) {
  if (date < minDate) return false
  if (date > maxDate) return false

  return true
}
